import { defaultInitialState } from '../utils';
import { FETCH_PLAN_CANCELLATION_FEE, FETCH_PLAN_CANCELLATION_FEE_DONE, FETCH_PLAN_CANCELLATION_FEE_ERR } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: [] });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PLAN_CANCELLATION_FEE:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case FETCH_PLAN_CANCELLATION_FEE_DONE:
            return Object.assign(Object.assign({}, state), { data: action.data, isLoading: false, error: false, errorMessage: null });
        case FETCH_PLAN_CANCELLATION_FEE_ERR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.errorMessage });
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map